import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';

import Style from './DeleteAccount.module.scss';

const DeleteAccount = ({ headerProps, language = {}, onClose, onDeleteAccount }) => {
  const {
    global_cancelButton: cancelButtonText,
    profileDelete_deleteButton: deleteButtonText,
    profileDelete_header: headerText,
    profileDelete_message: deleteMessage,
  } = language || {};

  return (
    <main className={Style.DeleteAccount}>
      <Header {...headerProps} />
      <div className={Style.DeleteAccountContainer}>
        <div className={Style.logoutContainer}>
          <div className={Style.logoutHeaderText}>{headerText}</div>
          <div className={Style.logoutText}>{deleteMessage}</div>
        </div>
        <div className={Style.btnWrap}>
          <button className={Style.deleteBtn} onClick={onDeleteAccount}>
            {deleteButtonText}
          </button>
          <button className={Style.cancelBtn} onClick={onClose}>
            {cancelButtonText}
          </button>
        </div>
      </div>
    </main>
  );
};

export default DeleteAccount;

DeleteAccount.defaultProps = {
  backgroundClass: null,
  headerProps: {},
  language: {},
  onClose: () => {},
  onDeleteAccount: () => {},
};

DeleteAccount.propTypes = {
  backgroundClass: PropTypes.string,
  headerProps: PropTypes.shape({}),
  language: PropTypes.shape({}),
  onClose: PropTypes.func,
  onDeleteAccount: PropTypes.func,
};
